import React from "react"

import Header from "../components/Header"
import RegisterComponentWrapper from "../components/register/RegisterComponentWrapper"

function Register() {
  return (
    <>
      <Header />
      <RegisterComponentWrapper />
    </>
  )
}

export default Register
